export const COMPLETE_PAYMENT_ACTION = "COMPLETE_PAYMENT_ACTION";

export const INIT_3DS2_VERIFICATION = "INIT_3DS2_VERIFICATION";

export const UPDATE_CART_BEGIN = "UPDATE_CART_BEGIN";
export const UPDATE_CART_SUCCESS = "UPDATE_CART_SUCCESS";
export const UPDATE_CART_FAILURE = "UPDATE_CART_FAILURE";

export const UPDATE_PAYMENT_INFO = "UPDATE_PAYMENT_INFO";

export const UPDATE_CARD_BIN = "UPDATE_CARD_BIN";
export const UPDATE_CARD_BRAND = "UPDATE_CARD_BRAND";

export const UPDATE_CART_PURCHASE = "UPDATE_CART_PURCHASE";

export const UPDATE_SPREEDLY_PAYMENT_METHOD = "UPDATE_SPREEDLY_PAYMENT_METHOD";
export const UPDATE_SPREEDLY_PAYMENT_DATA = "UPDATE_SPREEDLY_PAYMENT_DATA";

export const UPDATE_CURRENCY_BEGIN = "UPDATE_CURRENCY_BEGIN";
export const UPDATE_CURRENCY_SUCCESS = "UPDATE_CURRENCY_SUCCESS";
export const UPDATE_CURRENCY_FAILURE = "UPDATE_CURRENCY_FAILURE";

export const SHOW_ALERT = "SHOW_ALERT";
export const DISMISS_ALERT = "DISMISS_ALERT";

export const UPDATE_PAYMENT_TYPE = "UPDATE_PAYMENT_TYPE";

export const UPDATE_CART_CONTEXT = "UPDATE_CART_CONTEXT";

export const UPDATE_DEPARTURES = "UPDATE_DEPARTURES";

export const UPDATE_PURCHASE_STATE = "UPDATE_PURCHASE_STATE";
export const SHOW_PURCHASE_PROGRESS = "SHOW_PURCHASE_PROGRESS";
export const HIDE_PURCHASE_PROGRESS = "HIDE_PURCHASE_PROGRESS";

export const TOGGLE_SEAT_SELECTION_BEGIN = "TOGGLE_SEAT_SELECTION_BEGIN";
export const TOGGLE_SEAT_SELECTION_SUCCESS = "TOGGLE_SEAT_SELECTION_SUCCESS";
export const TOGGLE_SEAT_SELECTION_FAILURE = "TOGGLE_SEAT_SELECTION_FAILURE";

export const UPDATE_CONTACT_COUNTRY_CODE3 = "UPDATE_CONTACT_COUNTRY_CODE3";

export const UPDATE_INSTALLMENTS_PLANS_BEGIN =
  "UPDATE_INSTALLMENTS_PLANS_BEGIN";
export const UPDATE_INSTALLMENTS_PLANS_SUCCESS =
  "UPDATE_INSTALLMENTS_PLANS_SUCCESS";
export const UPDATE_INSTALLMENTS_PLANS_FAILURE =
  "UPDATE_INSTALLMENTS_PLANS_FAILURE";
export const CLEAR_INSTALLMENTS_PLANS = "CLEAR_INSTALLMENTS_PLANS";

export const UPDATE_CART_ITEMS_BEGIN = "UPDATE_CART_ITEMS_BEGIN";
export const UPDATE_CART_ITEMS_SUCCESS = "UPDATE_CART_ITEMS_SUCCESS";
export const UPDATE_CART_ITEM_SUCCESS = "UPDATE_CART_ITEM_SUCCESS";
export const UPDATE_CART_ITEMS_FAILURE = "UPDATE_CART_ITEMS_FAILURE";
export const REQUIRE_CART_ITEM_ACTION = "REQUIRE_CART_ITEM_ACTION";
export const RESOLVE_CART_ITEM_ACTION = "RESOLVE_CART_ITEM_ACTION";
export const TRACK_CART_ITEM_REMOVAL = "TRACK_CART_ITEM_REMOVAL";

export const UPDATE_TICKET_TYPES = "UPDATE_TICKET_TYPES";

export const UPDATE_REDIRECTION_SETUP = "UPDATE_REDIRECTION_SETUP";
export const UPDATE_ACTION_SETUP = "UPDATE_ACTION_SETUP";
